import flatMap from 'lodash/flatMap';
import sumBy from 'lodash/sumBy';

import { toNumOrZero } from '@cast/utils';

type WorkloadEventSeries = {
  eventType?: string;
  items?: { eventCount: string }[];
};

export const getOomCountFromEventSeries = (
  series?: WorkloadEventSeries[]
): number | undefined => {
  if (!series) {
    return undefined;
  }

  const oomSeries = series.filter((entry) => entry.eventType === 'OOMKilled');

  if (!oomSeries.length) {
    return 0;
  }

  return sumBy(
    flatMap(oomSeries, (entry) => entry.items ?? []),
    (item) => toNumOrZero(item.eventCount)
  );
};
